/**
 * Admin selector functions
 */
import { createSelector } from 'reselect';

/**
 * Retrieves the admin state from the global state
 */
const complianceReducer = (state) => state.get('complianceReducer');

/**
 * Retrieves loading state from admin reducer
 */
export const loadingSelector = createSelector(complianceReducer, (state) =>
  state.get('loading'),
);

/**
 * Retrieves error state from admin reducer
 */
export const errorSelector = createSelector(complianceReducer, (state) =>
  state.get('error'),
);

/**
 * Retrieves vendors state from admin reducer
 */
export const vendorSelector = createSelector(complianceReducer, (state) =>
  state.get('vendors').toJS(),
);

/**
 * Retrieves users state from admin reducer
 */
export const userSelector = createSelector(complianceReducer, (state) =>
  state.get('users').toJS(),
);

/**
 * Retrieves count state from admin reducer
 */
export const countSelector = createSelector(complianceReducer, (state) =>
  state.get('count'),
);

/**
 * Retrieves vendor count state from admin reducer
 */
export const vendorCountSelector = createSelector(complianceReducer, (state) =>
  state.get('vendorCount'),
);
